import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {defaultList, defaultRole} from "../generic/InitialStates";
import {AGCText} from "../../generic-components/AGCText";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {apiGenericCreate, apiGenericUpdate, genericGetOne, getAllPermissions} from "../generic/crud";
import {ENTITY_ID_ROLE} from "../generic/Constants";

export function RoleAddEditDialog(props) {
    const {show, handleClose, id, reloadData} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultRole);
    const [permissions, setAllPermissions] = useState(defaultList);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Role");
    const entityName = "Role";
    const [selectedPermissionsData, setSelectedPermissionsData] = useState([]);


    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(role, {resetForm}) {
            setIsLoading(true);
            role.allowedPermissions = selectedPermissionsData;

            if (!id) {
                apiGenericCreate(ENTITY_ID_ROLE, role).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    reloadData();
                    setSelectedPermissionsData([])
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_ROLE, role, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    reloadData();
                    setSelectedPermissionsData([])
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(false);

            genericGetOne(ENTITY_ID_ROLE, id).then(
                ({data}) => {
                    setSelectedPermissionsData(data.allowedPermissions);
                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultRole);
            setTitle("New " + entityName);
        }


        getAllPermissions().then(
            ({data}) => {
                setAllPermissions(data);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    }, [show]);

    function checkboxClicked(checked, type, id, permissionEnum, entityId) {
        setSelectedPermissionsData((prevState) => {
            // Find the index of the item with the matching ID in the existing state
            const index = prevState.findIndex((item) => item.id === id);

            if (index !== -1) {
                // If the item already exists in the state, update the corresponding type
                return prevState.map((item, i) => {
                    if (i === index) {
                        return {
                            ...item,
                            read: type === 1 ? checked : item.read,
                            update: type === 2 ? checked : item.update,
                            create: type === 3 ? checked : item.create,
                            delete: type === 4 ? checked : item.delete,
                            permission: permissionEnum,
                            entityId: entityId
                        };
                    }
                    return item;
                });
            } else {
                // If the item doesn't exist in the state, create a new entry
                return [
                    ...prevState,
                    {
                        id: id,
                        read: type === 1 ? checked : false,
                        update: type === 2 ? checked : false,
                        create: type === 3 ? checked : false,
                        delete: type === 4 ? checked : false,
                        permission: permissionEnum,
                        entityId: entityId
                    },
                ];
            }
        });
    }


    const permissionsMarkup = permissions.entities.map((permission) => {
        return (
            <tr key={permission.id}>
                <td className="text-gray-800">
                    {permission.name}
                    <div className={'text-muted fs-8'}>{permission.description}</div>
                </td>
                <td>
                    <div className="d-flex">
                        <label className="form-check form-check-sm form-check-custom form-check-solid me-3 me-lg-20">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="user_management_read"
                                checked={selectedPermissionsData.some(
                                    (item) => item.id === permission.id && item.read
                                )}
                                onChange={(event) =>
                                    checkboxClicked(event.target.checked, 1, permission.id, permission.value, permission.entityId)
                                }
                            />
                            <span className="form-check-label">Read</span>
                        </label>
                        <label className="form-check form-check-custom form-check-solid me-3 me-lg-20">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="user_management_update"
                                checked={selectedPermissionsData.some(
                                    (item) => item.id === permission.id && item.update
                                )}
                                onChange={(event) => checkboxClicked(event.target.checked, 2, permission.id, permission.value, permission.entityId)}
                            />
                            <span className="form-check-label">Update</span>
                        </label>
                        <label className="form-check form-check-custom form-check-solid me-3 me-lg-20">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="user_management_create"
                                checked={selectedPermissionsData.some(
                                    (item) => item.id === permission.id && item.create
                                )}
                                onChange={(event) => checkboxClicked(event.target.checked, 3, permission.id, permission.value, permission.entityId)}
                            />
                            <span className="form-check-label">Create</span>
                        </label>

                        <label className="form-check form-check-custom form-check-solid">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="user_management_delete"
                                checked={selectedPermissionsData.some(
                                    (item) => item.id === permission.id && item.delete
                                )}
                                onChange={(event) => checkboxClicked(event.target.checked, 4, permission.id, permission.value, permission.entityId)}
                            />
                            <span className="form-check-label">Delete</span>
                        </label>
                    </div>
                </td>
            </tr>
        );
    });

    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <div className="modal-body scroll-y">
                        <form
                            id="kt_modal_update_role_form"
                            className="form fv-plugins-bootstrap5 fv-plugins-framework"
                            action="#">
                            <div
                                className="d-flex flex-column scroll-y me-n7 pe-7"
                                id="kt_modal_update_role_scroll"
                                data-kt-scroll="true"
                                data-kt-scroll-activate="{default: false, lg: true}"
                                data-kt-scroll-max-height="auto"
                                data-kt-scroll-dependencies="#kt_modal_update_role_header"
                                data-kt-scroll-wrappers="#kt_modal_update_role_scroll"
                                data-kt-scroll-offset="300px"
                                style={{maxHeight: 531}}>
                                <div className="form-group row">
                                    <Form.Group className="col-lg-4">

                                        <AGCText formik={formik}
                                                 name={"Role Name"}
                                                 placeHolder={'Enter Role Name'}
                                                 id={"name"}
                                                 toolTip={"Please enter the Role Name."}
                                                 value={formik.values.name}/>
                                    </Form.Group>
                                    <Form.Group className="col-lg-8">
                                        <AGCText formik={formik}
                                                 name={"Description"}
                                                 placeHolder={'Enter Role Description'}
                                                 id={"description"}
                                                 toolTip={"Please enter the Description, This will help you identify the Role."}
                                                 value={formik.values.description}/>
                                    </Form.Group>
                                </div>
                                <br/>
                                <br/>
                                <div className="fv-row">
                                    <label className="fs-5 fw-bold form-label mb-2">Role Permissions</label>
                                    <span className={'separator'}/>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-row-dashed fs-6 gy-5">
                                            <tbody className="text-gray-600 fw-semibold">
                                            {permissionsMarkup}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <div
                                    className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                                    <i className="ki-duotone ki-information fs-2tx text-primary me-4">
                                        <span className="path1"/>
                                        <span className="path2"/>
                                        <span className="path3"/>
                                    </i>
                                    <div className="d-flex flex-stack flex-grow-1">
                                        <div className="fw-semibold">
                                            <div
                                                className="fs-6 text-gray-700"
                                                dangerouslySetInnerHTML={{__html: "If Either <b>Update</b>, <b>Create</b> or <b>Delete</b> is enabled for a Permission, <b>Read</b> Permission wil be automatically enabled. Also, Some of the Read Permissions are Enabled by Default"}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Modal.Footer>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-light btn-elevate"
                                        onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <> </>
                                    <button
                                        type="submit"
                                        onClick={formik.handleSubmit}
                                        className="btn btn-primary btn-elevate">
                                        Save
                                    </button>
                                </div>
                            </Modal.Footer>
                        </form>
                    </div>

                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
